<template>
  <div v-if="errorText" class="banner error primary-error">{{ errorText }}</div>
</template>
<script>
export default {
  props: ['errors', 'fields', 'exclude'],

  computed: {
    errorText() {
      let errors = [];
      if (this.errors && Object.keys(this.errors).length) {
        if (this.fields) {
          this.fields.forEach((f) => {
            errors = [...errors, ...(this.errors[f] || [])];
          });
        } else {
          Object.values(this.errors).forEach((errorArray) => {
            errors = [...errors, ...errorArray];
          });
        }
      }

      if (errors.length >= 1) {
        return errors[0];
      }
      return null;
    },
  },
};
</script>
<style>
.banner.error {
  box-sizing: border-box;
  white-space: pre-wrap;
  font-family: inherit;
  margin-bottom: 30px;
}
</style>
